import { CheckboxItem } from '@radix-ui/react-dropdown-menu';
import classNames from 'classnames';
import type React from 'react';
import { TooltipBubble } from '../../TooltipBubble';
import { TextBase } from '../../Typography';
import type { DropdownFilterItemContent } from '../types';

export type RenderItem<T extends string> = (
  props: Omit<MultiDropdownFilterItemProps<T>, 'renderItem'>
) => React.ReactElement;

export type MultiDropdownFilterItemProps<T extends string> = {
  item: DropdownFilterItemContent<T>;
  onChange: () => void;
  checked: boolean;
  disabled?: boolean;
  renderItem?: RenderItem<T>;
};
export function MultiDropdownFilterItem<T extends string>({
  item,
  onChange,
  checked,
  renderItem,
  disabled,
}: MultiDropdownFilterItemProps<T>) {
  return (
    <TooltipBubble
      placement="top"
      title={item.label}
    >
      <label>
        <CheckboxItem
          asChild
          textValue=""
          onSelect={(event) => {
            event.preventDefault();
          }}
        >
          {renderItem ? (
            renderItem({
              item,
              onChange,
              checked,
              disabled,
            })
          ) : (
            <div className="px-2 h-9 cursor-pointer flex items-center w-full gap-2 focus:bg-ds-natural-50 focus:outline-none focus:rounded-md">
              <input
                checked={checked}
                onChange={onChange}
                type="checkbox"
                className={classNames(
                  `rounded-sm
              border
              outline-none
              active:outline-none
              active:ring-0
              active:ring-offset-0
              focus:outline-none
              focus:ring-0
              focus:ring-offset-0`,
                  checked
                    ? 'hover:text-ds-primary-400 text-ds-primary active:text-ds-primary-500 cursor-pointer'
                    : `cursor-pointer
                   text-ds-primary
                   border-ds-natural-200
                   hover:border-ds-primary-400
                   active:border-ds-primary-500
                   `
                )}
              />
              <TextBase
                color="text-ds-natural-600"
                label={item.label}
                ellipsis
              />
            </div>
          )}
        </CheckboxItem>
      </label>
    </TooltipBubble>
  );
}
